import { render, staticRenderFns } from "./IncorporationEscalationFile.vue?vue&type=template&id=3061352f&scoped=true&"
import script from "./IncorporationEscalationFile.vue?vue&type=script&lang=js&"
export * from "./IncorporationEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./IncorporationEscalationFile.vue?vue&type=style&index=0&id=3061352f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061352f",
  null
  
)

export default component.exports